<template>
  <div class="charing-revenue">
    <div class="charing-revenue-top">
      <span class="top-left">充电收入</span>
      <div class="top-right">
        <el-select
          v-model="provincesName"
          clearable
          placeholder="请选择"
          @change="getCity(provincesName)"
        >
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="cityName"
          clearable
          placeholder="请选择"
          @change="getStations(cityName)"
        >
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="stationName"
          clearable
          placeholder="请选择场站"
          @change="stationChange"
        >
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="charing-revenue-bottom">
      <div class="top">
        <div
          class="income-ranking"
          id="income-ranking"
          :style="{ height: height1 + 'px' }"
        >
          <div class="income-data">
            <div class="income-list income-list-o">
              <span class="list-bg"></span>
              <span class="income-title">今日收入</span>
              <span class="income-money">
                <span>{{ day_income }} </span>
                <span class="yuan" :class="yuanA == true ? 'yuanA' : ''"
                  >元</span
                >
              </span>
              <div style="clear: both"></div>
            </div>
            <div class="income-list">
              <span class="list-bg list-bg2"></span>
              <span class="income-title">本月总收入</span>
              <span class="income-money">
                <span>{{ month_income }} </span>
                <span class="yuan" :class="yuanA2 == true ? 'yuanA' : ''"
                  >元</span
                >
              </span>
              <div style="clear: both"></div>
            </div>            
          </div>
        </div>
        <div
          class="income-loss"
          id="income-loss"
          :style="{ height: height1 + 'px' }"
        >
          <div class="income-loss-box">
            <div class="income-loss-echarts">
              <div id="ilsf-echarts" style="width: 100%; height: 100%"></div>
            </div>
            <div class="i-l-title">
              <span class="title-l">收入与电量</span>
              <span class="title-r">
                <span
                  class="title-r-day"
                  :class="activeIL == 1 ? 'active' : ''"
                  @click="ildayClick(1)"
                  >日</span
                >
                <span>/</span>
                <span
                  class="title-r-month"
                  :class="activeIL == 2 ? 'active' : ''"
                  @click="ilmonthClick(2)"
                  >月</span
                >
              </span>
              <!-- <div style="clear:both;"></div> -->
            </div>
          </div>
          <div class="income-ranking-box">
            <div class="ir-title">
              <span class="ir-title-l">收入排行</span>
              <span class="ir-title-r">
                <span
                  class="day"
                  :class="activeIR == 1 ? 'active' : ''"
                  @click="irClick(1)"
                  >日</span
                >
                <span>/</span>
                <span
                  class="month"
                  :class="activeIR == 2 ? 'active' : ''"
                  @click="irClick(2)"
                  >月</span
                >
              </span>
              <div style="clear: both"></div>
            </div>
            <div class="ir-list">
              <ul>
                <li v-for="(item, index) in incomeRankingList" :key="index">
                  <span class="number">{{ index + 1 }}</span>
                  <span class="station-name">{{ item.charger_name }}</span>
                  <span class="money"
                    ><span class="money-num">{{ item.total_fee }}</span
                    >元<span
                      class="arrow"
                      :class="item.arrow == 'rise' ? 'arrow-up' : 'arrow-down'"
                    ></span
                  ></span>
                </li>
              </ul>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="operation-index" :style="{ height: height1 + 'px' }">
          <div class="operation-index-echarts">
            <div id="oi-echarts" style="width: 100%; height: 100%"></div>
          </div>
          <div class="oi-title">
            <span class="oi-title-l">运营指标</span>
            <span class="oi-title-r">
              <span
                class="day"
                :class="activeOI == 1 ? 'active' : ''"
                @click="oiClick(1)"
                >日</span
              >
              <span>/</span>
              <span
                class="month"
                :class="activeOI == 2 ? 'active' : ''"
                @click="oiClick(2)"
                >月</span
              >
            </span>
            <div style="clear: both"></div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="bottom">
        <div class="order-status" :style="{ height: height1 + 'px' }">
          <div class="ot-title">
            <span class="ot-title-l">订单状态</span>
            <span class="ot-title-r">
              <span
                class="day"
                :class="activeOT == 1 ? 'active' : ''"
                @click="otClick(1)"
                >日</span
              >
              <span>/</span>
              <span
                class="month"
                :class="activeOT == 2 ? 'active' : ''"
                @click="otClick(2)"
                >月</span
              >
            </span>
            <div style="clear: both"></div>
          </div>
          <div class="order-status-echarts">
            <div id="ot-echarts" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div class="charge-distribution" :style="{ height: height1 + 'px' }">
          <div class="charge-distribution-box">
            <div class="charge-distribution-echarts">
              <div id="cdfb-echarts" style="width: 100%; height: 100%"></div>
            </div>
            <div class="c-d-title">
              <span class="title-l">充电分布</span>
              <span class="title-r">
                <span
                  class="title-r-day"
                  :class="activeCD == 1 ? 'active' : ''"
                  @click="cdClick(1)"
                  >日</span
                >
                <span>/</span>
                <span
                  class="title-r-month"
                  :class="activeCD == 2 ? 'active' : ''"
                  @click="cdClick(2)"
                  >月</span
                >
              </span>
              <!-- <div style="clear:both;"></div> -->
            </div>
          </div>
          <div class="alarm-box">
            <div class="alarm-title">
              <span class="alarm-title-l">充电次数排行</span>
              <span class="alarm-title-r">
                <span
                  class="day"
                  :class="activeAL == 1 ? 'active' : ''"
                  @click="alClick(1)"
                  >日</span
                >
                <span>/</span>
                <span
                  class="month"
                  :class="activeAL == 2 ? 'active' : ''"
                  @click="alClick(2)"
                  >月</span
                >
              </span>
              <div style="clear: both"></div>
            </div>
            <div class="alarm-list">
              <ul>
                <li v-for="(item, index) in alarmRanking" :key="index">
                  <span class="number">{{ index + 1 }}</span>
                  <span class="station-name">{{ item.charger_name }}</span>
                  <span class="money"
                    ><span class="money-num">{{ item.total_degree }}</span
                    >次<span
                      class="arrow"
                      :class="item.arrow == 'rise' ? 'arrow-up' : 'arrow-down'"
                    ></span
                  ></span>
                </li>
              </ul>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="income-ratio" :style="{ height: height1 + 'px' }">
          <div class="income-ratio-title">
            <span class="income-ratio-title-l">收入占比</span>
            <span class="income-ratio-title-r">
              <span
                class="day"
                :class="activeRatio == 1 ? 'active' : ''"
                @click="ratioClick(1)"
                >日</span
              >
              <span>/</span>
              <span
                class="month"
                :class="activeRatio == 2 ? 'active' : ''"
                @click="ratioClick(2)"
                >月</span
              >
            </span>
            <div style="clear: both"></div>
          </div>
          <div class="income-ratio-echarts">
            <div id="ratio-echarts" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      provincesName: "",
      provincesList: [],
      cityList: [],
      cityName: "",
      stationList: [],
      stationName: "",
      stationId: "",
      width1: "",
      height1: "",
      height2: "",
      width1: "",
      day_income: "", //今日收入
      month_income: "", //本月总收入
      year_income: "", //	今年总收入
      yuanA: false,
      yuanA2: false,
      yuanA3: false,
      activeIL: 1,
      incomeAndLossDayList: [],
      incomeAndLossMonthList: [],
      chargingServiceFeeDayList: [],
      chargingServiceFeeMonthList: [],
      activeIR: 1,
      incomeRankingDefaultList: [],
      incomeRankingList: [],
      activeOI: 1,
      operationList: [],
      operationMonthList: [],
      activeOT: 1,
      orderStatusObj: {
        charging_num: "", //进行中订单数
        unfinished_num: "", //	未结算订单数
        complete_num: "", //已完成订单数
        order_num: "", //	总订单数
      },
      activeAL: 1,
      dataZoomStart: 0,
      dataZoomEnd: 100,
      chargeDistributionDayList: [],
      chargeDistributionMonthList: [],
      activeCD: 1,
      alarmRanking: [],
      activeRatio: 1,
      incomeRatioList: [],
      total_fee: "",
      data304: "0",
      getRechargeRateRanking: {}, //充电次数
    };
  },
  beforeCreate() {
    // document.getElementsByTagName("body")[0].className="charging-body";
  },
  beforeDestroy() {
    document.body.removeAttribute("class", "charging-body");
  },
  mounted() {
    document.getElementsByTagName("body")[0].className = "charging-body";
    let o = document.getElementById("income-ranking");
    this.width1 = o.clientWidth || o.offsetWidth;
    this.height1 = this.width1 / 1.152;

    let o2 = document.getElementById("income-loss");
    this.width2 = o2.clientWidth || o2.offsetWidth;
    this.height2 = this.width2 / 2.377;

    this.$nextTick(function () {
      this.getProvinces();
    });
  },
  methods: {
    getProvinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesList = su.data.list;
            this.provincesName = this.$store.state.crProvinces
              ? this.$store.state.crProvinces
              : this.provincesList[0].province;
            this.getCity2(
              this.$store.state.crProvinces
                ? this.$store.state.crProvinces
                : this.provincesList[0].province
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getCity(province) {
      this.cityName = "";
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getCity2(province) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
            this.cityName = this.$store.state.crCity
              ? this.$store.state.crCity
              : this.cityList[0].city;
            if (this.cityName == "深圳") {
              this.cityName = "深圳市";
            }
            if (this.$store.state.crCity == "深圳") {
              this.$store.state.crCity = "深圳市";
            }
            this.getStations2(
              this.$store.state.crCity
                ? this.$store.state.crCity
                : this.cityList[0].city
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStations(city) {
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStations2(city) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
            this.stationName = this.$store.state.crStation
              ? this.$store.state.crStation
              : this.stationList[0].station_name;
            this.stationId = this.$store.state.crStation
              ? this.$store.state.crStation
              : this.stationList[0].station_id;

            this.getTotalState(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //总收入
            this.getIncomeAndLoss(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //收入与损耗
            // this.getChargingServiceFeeDay(this.$store.state.crStation?this.$store.state.crStation:this.stationList[0].station_id);//充电量与服务费
            this.getIncomeRanking(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //收入排行
            this.getOperation(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //运营指标
            this.getOrderStatus(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //订单状态
            this.getChargeDistribution(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //充电分布
            this.getAlarmRanking(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //告警排行
            this.getIncomeRatio(
              this.$store.state.crStation
                ? this.$store.state.crStation
                : this.stationList[0].station_id
            ); //收入占比
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationChange(data) {
      this.stationId = data;
      this.$store.commit("changeCrProvinces", this.provincesName);
      this.$store.commit("changeCrCity", this.cityName);
      this.$store.commit("changeCrStation", this.stationId);
      // this.activeIL = 1;
      // this.activeIR = 1;
      // this.activeOI = 1;
      // this.activeOT = 1;
      // this.activeAL = 1;
      // this.activeCD = 1;
      // this.activeRatio = 1;
      this.getTotalState(this.stationId); //总收入
      this.getIncomeAndLoss(this.stationId); //收入与损耗
      // this.getChargingServiceFeeDay(this.stationId);//充电量与服务费
      this.getIncomeRanking(this.stationId); //收入排行
      this.getOperation(this.stationId); //运营指标
      this.getOrderStatus(this.stationId); //订单状态
      this.getChargeDistribution(this.stationId); //充电分布
      this.getAlarmRanking(this.stationId); //告警排行
      this.getIncomeRatio(this.stationId); //收入占比
    },
    getTotalState(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getTotalState",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.day_income = su.data.day_income;
            this.month_income = su.data.month_income;
            this.year_income = su.data.year_income;
            if (this.day_income == 0) {
              this.yuanA = true;
            } else {
              this.yuanA = false;
            }
            if (this.month_income == 0) {
              this.yuanA2 = true;
            } else {
              this.yuanA2 = false;
            }
            if (this.year_income == 0) {
              this.yuanA3 = true;
            } else {
              this.yuanA3 = false;
            }
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //!!!
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      // 　　return tYear+"/"+tMonth+"/"+tDate;
      return tMonth + "/" + tDate;
    },
    getIncomeAndLoss(stationId) {
      if (this.activeIL == 1) {
        this.getIncomeAndLossDay(stationId);
        this.getChargingServiceFeeDay(stationId);
      } else if (this.activeIL == 2) {
        this.getIncomeAndLossMonth(stationId);
        this.getChargingServiceFeeMonth(stationId);
      }
    },
    getIncomeAndLossDay(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getIncomeAndLoss",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.incomeAndLossDayList = su.data.date;
            this.drawIncomeAndLoss(
              this.incomeAndLossDayList,
              this.chargingServiceFeeDayList,
              1
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            // let arr1 = [];
            // let arr2 = [];
            this.data304 = 1;
            // arr1.push({date:this.getDay(-1)});
            // arr1.push({date:this.getDay(-2)});
            // arr1.push({date:this.getDay(-3)});
            // arr1.push({date:this.getDay(-4)});
            // arr1.push({date:this.getDay(-5)});
            // arr1.push({date:this.getDay(-6)});
            // arr1.push({date:this.getDay(-7)});
            // arr1 = arr1.reverse();
            this.incomeAndLossDayList = [];
            this.drawIncomeAndLoss(
              this.incomeAndLossDayList,
              this.chargingServiceFeeDayList,
              1
            );
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getChargingServiceFeeDay(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getChargingServiceFee",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.chargingServiceFeeDayList = su.data.date;
            this.drawIncomeAndLoss(
              this.incomeAndLossDayList,
              this.chargingServiceFeeDayList,
              1
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            // let arr1 = [];
            // let arr2 = [];
            this.data304 = 2;
            // arr2.push({date:this.getDay(-1),total_power_fee: 0});
            // arr2.push({date:this.getDay(-2),total_power_fee: 0});
            // arr2.push({date:this.getDay(-3),total_power_fee: 0});
            // arr2.push({date:this.getDay(-4),total_power_fee: 0});
            // arr2.push({date:this.getDay(-5),total_power_fee: 0});
            // arr2.push({date:this.getDay(-6),total_power_fee: 0});
            // arr2.push({date:this.getDay(-7),total_power_fee: 0});
            this.chargingServiceFeeDayList = [];
            this.drawIncomeAndLoss(
              this.incomeAndLossDayList,
              this.chargingServiceFeeDayList,
              1
            );
          }
        })
        .catch((err) => {});

      // debugger
    },
    getIncomeAndLossMonth(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getIncomeAndLossMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.incomeAndLossMonthList = su.data.date;
            this.drawIncomeAndLoss(
              this.incomeAndLossMonthList,
              this.chargingServiceFeeMonthList,
              2
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            let arr1 = [];
            let arr2 = [];
            // arr1.push({date:this.getDay(-1)});
            // arr1.push({date:this.getDay(-2)});
            // arr1.push({date:this.getDay(-3)});
            // arr1.push({date:this.getDay(-4)});
            // arr1.push({date:this.getDay(-5)});
            // arr1.push({date:this.getDay(-6)});
            // arr1.push({date:this.getDay(-7)});
            this.drawIncomeAndLoss(arr1, arr2, 2);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getChargingServiceFeeMonth(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getChargingServiceFeeMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.chargingServiceFeeMonthList = su.data.date;
            this.drawIncomeAndLoss(
              this.incomeAndLossMonthList,
              this.chargingServiceFeeMonthList,
              2
            );
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            let arr1 = [];
            let arr2 = [];
            // arr2.push({date:this.getDay(-1),total_power_fee: 0});
            // arr2.push({date:this.getDay(-2),total_power_fee: 0});
            // arr2.push({date:this.getDay(-3),total_power_fee: 0});
            // arr2.push({date:this.getDay(-4),total_power_fee: 0});
            // arr2.push({date:this.getDay(-5),total_power_fee: 0});
            // arr2.push({date:this.getDay(-6),total_power_fee: 0});
            // arr2.push({date:this.getDay(-7),total_power_fee: 0});
            this.drawIncomeAndLoss(arr1, arr2, 2);
          }
        })
        .catch((err) => {});
    },
    drawIncomeAndLoss(arr1, arr2, num) {
      // console.log(arr1);
      // console.log(arr2);
      let dataX = [];
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];

      if (num == 1) {
        if (arr1.length == 0) {
          arr1.push({ date: this.getDay(-1), charge_power: 0 });
          arr1.push({ date: this.getDay(-2), charge_power: 0 });
          arr1.push({ date: this.getDay(-3), charge_power: 0 });
          arr1.push({ date: this.getDay(-4), charge_power: 0 });
          arr1.push({ date: this.getDay(-5), charge_power: 0 });
          arr1.push({ date: this.getDay(-6), charge_power: 0 });
          arr1.push({ date: this.getDay(-7), charge_power: 0 });
          arr1 = arr1.reverse();
        }

        for (let i in arr1) {
          dataX.push(arr1[i].date);
          data1.push(arr1[i].charge_power);
          data2.push(arr1[i].meter_loss);
        }
      } else if (num == 2) {
        for (let i in arr1) {
          dataX.push(arr1[i].date.substring(3, 5));
          data1.push(arr1[i].charge_power);
          data2.push(arr1[i].meter_loss);
        }
      }

      if (num == 1) {
        if (arr2.length == 0) {
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
          arr2.push({ total_power_fee: 0 });
        }

        for (let i in arr2) {
          data3.push(arr2[i].total_power_fee);
          data4.push(arr2[i].total_serv_fee);
        }
      } else if (num == 2) {
        for (let i in arr2) {
          data3.push(arr2[i].total_power_fee);
          data4.push(arr2[i].total_serv_fee);
        }
      }

      let echart = echarts.init(document.getElementById("ilsf-echarts"));
      var option = {
        color: ["#4c8fff", "#00dedb", "#fdbe21", "#22ad50"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "充电电量") {
                txtCon +=
                  arr[i].marker +
                  "充电电量" +
                  " : " +
                  arr[i].data +
                  " 度" +
                  "<br/>";
              } else if (arr[i].seriesName == "总用电量") {
                txtCon +=
                  arr[i].marker +
                  "总用电量" +
                  " : " +
                  arr[i].data +
                  " 度" +
                  "<br/>";
              } else if (arr[i].seriesName == "充电费") {
                txtCon +=
                  arr[i].marker +
                  "充电费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              } else if (arr[i].seriesName == "服务费") {
                txtCon +=
                  arr[i].marker +
                  "服务费" +
                  " : " +
                  arr[i].data +
                  " 元" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          bottom: 0,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 0,
          data: [
            {
              name: "充电电量",
              textStyle: {
                fontSize: "12px",
              },
              icon: "circle",
            },
            {
              name: "总用电量",
              textStyle: {
                fontSize: "12px",
              },
              icon: "circle",
            },
            {
              name: "充电费",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "服务费",
              textStyle: {
                fontSize: "12px",
              },
            },
          ],
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        grid: {
          containLabel: true,
          right: "2%",
          left: "4%",
          bottom: "6%",
        },
        series: [
          {
            name: "充电电量",
            type: "bar",
            data: data1,
            barWidth: 24,
          },
          {
            name: "总用电量",
            type: "bar",
            data: data2,
            barWidth: 24,
          },
          {
            name: "充电费",
            type: "line",
            data: data3,
            symbol: "circle",
          },
          {
            name: "服务费",
            type: "line",
            data: data4,
            symbol: "circle",
          },
        ],
      };
      echart.setOption(option);
    },
    ildayClick(num) {
      this.activeIL = num;
      this.getIncomeAndLossDay(this.stationId); //收入与损耗
      this.getChargingServiceFeeDay(this.stationId); //充电量与服务费
    },
    ilmonthClick(num) {
      this.activeIL = num;
      this.getIncomeAndLossMonth(this.stationId); //收入与损耗
      this.getChargingServiceFeeMonth(this.stationId); //充电量与服务费
    },
    irClick(num) {
      this.activeIR = num;
      if (num == 1) {
        this.incomeRankingList = this.incomeRankingDefaultList.data_day;
      } else if (num == 2) {
        this.incomeRankingList = this.incomeRankingDefaultList.data_month;
      }
    },
    getIncomeRanking(stationId) {
      this.incomeRankingDefaultList = [];
      this.incomeRankingList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getIncomeRanking",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.incomeRankingDefaultList = su.data.date;
            this.incomeRankingList = su.data.date.data_day;
            if (this.activeIR == 1) {
              this.incomeRankingList = this.incomeRankingDefaultList.data_day;
            } else if (this.activeIR == 2) {
              this.incomeRankingList = this.incomeRankingDefaultList.data_month;
            }
            if (this.incomeRankingList.length > 10) {
              this.incomeRankingList = this.incomeRankingList.slice(0, 10);
            }
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    oiClick(num) {
      if (num == 1) {
        this.activeOI = 1;
        this.getOperationDay(this.stationId);
      } else if (num == 2) {
        this.activeOI = 2;
        this.getOperationMonth(this.stationId);
      }
    },
    getOperation(stationId) {
      if (this.activeOI == 1) {
        this.getOperationDay(stationId);
      } else if (this.activeOI == 2) {
        this.getOperationMonth(stationId);
      }
    },
    getOperationDay(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getOperation",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.operationList = su.data.date;
            for (let i in this.operationList) {
              this.operationList[i].charge_time = (
                this.operationList[i].charge_time / 3600
              ).toFixed(2);
            }
            this.drawOperation(this.operationList, 1);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            let arr1 = [];
            let arr2 = [];
            arr1.push({ date: this.getDay(-1), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-2), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-3), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-4), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-5), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-6), charge_power: "0.00" });
            arr1.push({ date: this.getDay(-7), charge_power: "0.00" });
            arr1 = arr1.reverse();
            this.drawOperation(arr1, 1);
          }
        })
        .catch((err) => {});
    },
    getOperationMonth(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getOperationMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.operationMonthList = su.data.date;
            for (let i in this.operationMonthList) {
              this.operationMonthList[i].charge_time = (
                this.operationMonthList[i].charge_time / 3600
              ).toFixed(2);
            }
            this.drawOperation(this.operationMonthList, 2);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            let arr1 = [];
            let arr2 = [];
            arr1.push({ date: this.getDay(-1) });
            arr1.push({ date: this.getDay(-2) });
            arr1.push({ date: this.getDay(-3) });
            arr1.push({ date: this.getDay(-4) });
            arr1.push({ date: this.getDay(-5) });
            arr1.push({ date: this.getDay(-6) });
            arr1.push({ date: this.getDay(-7) });
            // arr1.push({date:this.getDay(-7),charge_power:0,charge_time:0});
            this.drawOperation(arr1, 1);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    calMax(arr) {
      // console.log(arr);
      // debugger
      for (let j in arr) {
        arr[j] = Number(arr[j]);
      }
      var max = arr[0];
      for (var i = 1; i < arr.length; i++) {
        // 求出一组数组中的最大值
        if (max < arr[i]) {
          max = arr[i];
        }
      }
      var maxint = Math.ceil(max / 10); // 向上取整
      // console.log(maxint);
      var maxval = maxint * 10; // 最终设置的最大值
      // console.log(maxval);
      return maxval; // 输出最大值
    },
    drawOperation(arr, num) {
      // console.log(arr);
      let dataX = [];
      let charge_power = []; //使用率
      let charge_time = []; //充电时长
      if (num == 1) {
        for (let i in arr) {
          dataX.push(arr[i].date);
          charge_power.push(arr[i].charge_power);
          charge_time.push(arr[i].charge_time);
        }
      } else if (num == 2) {
        for (let i in arr) {
          dataX.push(arr[i].date.substring(3, 5));
          charge_power.push(arr[i].charge_power);
          charge_time.push(arr[i].charge_time);
        }
      }

      var maxappreg = this.calMax(charge_power); //使用率
      var maxactive = this.calMax(charge_time); //充电时长
      var interval_left = Math.ceil(maxappreg / 5); //左轴间隔
      var interval_right = Math.ceil(maxactive / 5); //右轴间隔
      // return

      let echart = echarts.init(document.getElementById("oi-echarts"));
      var option = {
        color: ["#4c8fff", "#00b74d"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "使用率") {
                txtCon +=
                  arr[i].marker +
                  "使用率" +
                  " : " +
                  arr[i].data +
                  " %" +
                  "<br/>";
              } else if (arr[i].seriesName == "充电时长") {
                txtCon +=
                  arr[i].marker +
                  "充电时长" +
                  " : " +
                  arr[i].data +
                  " 小时" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          bottom: 0,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 0,
          data: [
            {
              name: "使用率",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "充电时长",
              textStyle: {
                fontSize: "12px",
              },
              icon: "circle",
            },
          ],
        },
        xAxis: {
          type: "category",
          data: dataX,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxappreg,
            splitNumber: 5,
            interval: interval_left,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxactive,
            splitNumber: 5,
            interval: interval_right,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
        ],
        grid: {
          containLabel: true,
          // right:this.width1<350?(this.width1<310?"16%":"16%"):"14%",
          // left:this.width1<350?(this.width1<310?"14%":"14%"):"12%",
          right: "4%",
          left: "4%",
          bottom: "6%",
        },
        series: [
          {
            name: "使用率",
            type: "line",
            data: charge_power,
            symbol: "circle",
            yAxisIndex: 0,
          },
          {
            name: "充电时长",
            type: "bar",
            data: charge_time,
            yAxisIndex: 1,
            barWidth: 24,
          },
        ],
      };
      echart.setOption(option);
    },
    otClick(num) {
      if (num == 1) {
        this.activeOT = 1;
        this.getOrderStatusDay(this.stationId);
      } else if (num == 2) {
        this.activeOT = 2;
        this.getOrderStatusMonth(this.stationId);
      }
    },
    getOrderStatus(stationId) {
      if (this.activeOT == 1) {
        this.getOrderStatusDay(stationId);
      } else if (this.activeOT == 2) {
        this.getOrderStatusMonth(stationId);
      }
    },
    getOrderStatusDay(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getOrderStatus",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.orderStatusObj.charging_num = su.data.charging_num;
            this.orderStatusObj.complete_num = su.data.complete_num;
            this.orderStatusObj.order_num = su.data.order_num;
            this.orderStatusObj.unfinished_num = su.data.unfinished_num;
            this.drawOrderStatus(this.orderStatusObj);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getOrderStatusMonth(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getOrderStatusMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.orderStatusObj.charging_num = su.data.charging_num;
            this.orderStatusObj.complete_num = su.data.complete_num;
            this.orderStatusObj.order_num = su.data.order_num;
            this.orderStatusObj.unfinished_num = su.data.unfinished_num;
            this.drawOrderStatus(this.orderStatusObj);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawOrderStatus(obj) {
      let data = [];
      data.push({ value: obj.complete_num, name: "已完成" });
      data.push({ value: obj.charging_num, name: "进行中" });
      data.push({ value: obj.unfinished_num, name: "未结算" });

      let echart = echarts.init(document.getElementById("ot-echarts"));
      var option = {
        tooltip: {
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            let txtCon = "";
            txtCon +=
              "订单数量" +
              "<br/>" +
              arr.marker +
              arr.data.name +
              " : " +
              arr.data.value +
              " 个" +
              "<br/>";
            return txtCon;
          },
        },
        color: ["#22ad50", "#fdce5a", "#0078bf"],
        legend: {
          bottom: this.width1 > 340 ? 8 : 0,
          left: "center",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10,
          // itemGap:0,//图例之间距离
          textStyle: {
            color: "#6ec5fb",
            fontSize: 10,
          },
          icon: "circle", //图例形状设置
          // data: this.type,
        },
        graphic: [
          //饼图中间数字和文字显示
          {
            type: "text",
            left: "center",
            top: "43%",
            z: 2,
            zlevel: 100,
            style: {
              text: "订单数量",
              fill: "#FFFFFD",
              font: "bold Microsoft YaHei",
              fontSize: this.width1 > 340 ? 14 : 12,
            },
          },
          {
            type: "text",
            left: "center",
            top: "52%",
            z: 2,
            zlevel: 100,
            style: {
              text: obj.order_num,
              fill: "#62cafd",
              fontWeight: 700,
              fontSize: this.width1 > 340 ? 26 : 18,
            },
          },
        ],
        series: [
          {
            name: "订单数量",
            type: "pie",
            radius: ["38%", "50%"],
            center: ["50%", "50%"],
            label: {
              //饼图线
              normal: {
                textStyle: {
                  fontSize: 10,
                },
                formatter: "{b}{per|{c}}\n",
                borderWidth: 20,
                borderRadius: 4,
                padding: [0, -40],
                rich: {
                  a: {
                    fontSize: 10,
                    lineHeight: 20,
                    align: "center",
                  },
                  per: {
                    align: "center",
                    fontSize: 10,
                  },
                  b: {
                    color: "#60c8ff",
                  },
                  c: {
                    color: "#60c8ff",
                  },
                },
              },
            },
            data: data,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}  \n {c}", //标题换行，按照自己的格式进行配置
                  // color:"#60c8ff"
                },
                labelLine: {
                  show: true,
                  length: 20,
                  length2: 40,
                },
                borderWidth: 4, //每个扇形直接留有空隙
                borderColor: "#0C1E2A", //空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          },
        ],
      };
      echart.setOption(option);
    },
    cdClick(num) {
      this.activeCD = num;
      if (num == 1) {
        this.getChargeDistributionDay(this.stationId);
      } else if (num == 2) {
        this.getChargeDistributionMonth(this.stationId);
      }
    },
    getChargeDistribution(stationId) {
      if (this.activeCD == 1) {
        this.getChargeDistributionDay(stationId);
      } else if (this.activeCD == 2) {
        this.getChargeDistributionMonth(stationId);
      }
    },
    getChargeDistributionDay(stationId) {
      this.chargeDistributionDayList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getChargeDistributionDay",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            for (let o in su.data.data) {
              this.chargeDistributionDayList.push(su.data.data[o]);
            }
            // this.chargeDistributionDayList = su.data.data;
            // this.chargeDistributionDayList = [
            //   {
            //     charging_num: 10000,
            //     station_id: "TDV0",
            //     time_interval: "01.00",
            //   },
            //   {
            //     charging_num: 85000,
            //     station_id: "TDV0",
            //     time_interval: "02.00",
            //   },
            //   {
            //     charging_num: 65000,
            //     station_id: "TDV0",
            //     time_interval: "03.00",
            //   },
            // ];
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargeDistributionDayList) {
              // that.chargeDistributionDayList[i].time_interval = that.chargeDistributionDayList[i].time_interval.substring(11,19);
              date.push(that.chargeDistributionDayList[i].time_interval);
              let num =
                Ymd +
                " " +
                that.chargeDistributionDayList[i].time_interval.substring(
                  0,
                  2
                ) +
                ":" +
                that.chargeDistributionDayList[i].time_interval.substring(
                  3,
                  5
                ) +
                ":00";
              powersList.push([
                num,
                that.chargeDistributionDayList[i].charging_num,
              ]);
            }
            this.drawChargeDistribution(date, powersList);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargeDistributionDayList) {
              // that.chargeDistributionDayList[i].time_interval = that.chargeDistributionDayList[i].time_interval.substring(11,19);
              date.push(that.chargeDistributionDayList[i].time_interval);
              let num =
                Ymd +
                " " +
                that.chargeDistributionDayList[i].time_interval.substring(
                  0,
                  2
                ) +
                ":" +
                that.chargeDistributionDayList[i].time_interval.substring(
                  3,
                  5
                ) +
                ":00";
              powersList.push([
                num,
                that.chargeDistributionDayList[i].charging_num,
              ]);
            }
            this.drawChargeDistribution(date, powersList);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getChargeDistributionMonth(stationId) {
      this.chargeDistributionMonthList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getChargeDistributionMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            for (let o in su.data.data) {
              this.chargeDistributionMonthList.push(su.data.data[o]);
            }
            // this.chargeDistributionMonthList = su.data.data;
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargeDistributionMonthList) {
              date.push(that.chargeDistributionMonthList[i].time_interval);
              let num =
                Ymd +
                " " +
                that.chargeDistributionMonthList[i].time_interval.substring(
                  0,
                  2
                ) +
                ":" +
                that.chargeDistributionMonthList[i].time_interval.substring(
                  3,
                  5
                ) +
                ":00";
              powersList.push([
                num,
                that.chargeDistributionMonthList[i].charging_num,
              ]);
            }
            this.drawChargeDistribution(date, powersList);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargeDistributionDayList) {
              // that.chargeDistributionDayList[i].time_interval = that.chargeDistributionDayList[i].time_interval.substring(11,19);
              date.push(that.chargeDistributionDayList[i].time_interval);
              let num =
                Ymd +
                " " +
                that.chargeDistributionDayList[i].time_interval.substring(
                  0,
                  2
                ) +
                ":" +
                that.chargeDistributionDayList[i].time_interval.substring(
                  3,
                  5
                ) +
                ":00";
              powersList.push([
                num,
                that.chargeDistributionDayList[i].charging_num,
              ]);
            }
            this.drawChargeDistribution(date, powersList);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawChargeDistribution(date, powersList) {
      // console.log(date);
      // console.log(powersList);
      var date = new Date();
      var Ymd = date.toLocaleDateString();
      // console.log(powersList);
      let echart = echarts.init(document.getElementById("cdfb-echarts"));
      var option = {
        color: ["#2fab65", "#10323e"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValueLabel.substring(0, 6) + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "充电分布") {
                txtCon +=
                  arr[i].marker +
                  "充电分布" +
                  " : " +
                  arr[i].data[1] +
                  " 人" +
                  "<br/>";
              }
            }
            // if(arr.length != 0){
            //   txtCon += arr[0].marker + "充电分布" + ' : '+ arr[0].data[1] + " 人" + '<br/>';
            // }
            // for(let i in arr){
            //   if(arr[i].seriesName == "充电分布"){
            //     txtCon += arr[i].marker + "充电分布" + ' : '+ arr[i].data[1] + " 人" + '<br/>';
            //   }
            // }
            return txtCon;
          },
        },
        grid: {
          // top:'10%',//距上边距
          // bottom:this.width2<790?'28%':'20%',//距离下边距
          // // right:"3%",
          // left:this.width2<720?'16%':"10%",
          containLabel: true,
          right: "2%",
          left: "4%",
          bottom: "10%",
        },
        xAxis: {
          type: "time",
          min: Ymd + " 00:00:00",
          max: Ymd + " 23:59:00",
          interval: 1 * 60 * 60 * 1000,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
            formatter: function (v) {
              var date = new Date(v);
              return `${("0" + date.getHours()).slice(-2)}:${(
                "0" + date.getMinutes()
              ).slice(-2)}`;
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        dataZoom: [
          {
            type: "slider", //图表下方的滚动条
            borderColor: "#06537F",
            fillerColor: "#0f313d", //选中范围的填充颜色。
            show: true, //是否显示
            start: this.dataZoomStart, //滚动条开始位置（1-100）
            end: this.dataZoomEnd, //滚动条结束位置（1-100）
            bottom: this.width2 < 720 ? 10 : 10,
            height: this.width2 < 720 ? 20 : 28,
            // left:"4%",
          },
        ],
        series: [
          {
            data: powersList,
            name: "充电分布",
            type: "line",
            symbol: "none",
            smooth: true,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0E303C",
                  },
                ]),
              },
            },
          },
        ],
      };
      var self = this;
      echart.on("datazoom", function (params) {
        self.dataZoomStart = params.start;
        self.dataZoomEnd = params.end;
      });

      echart.setOption(option);
    },
    alClick(num) {
      this.activeAL = num;
      if (num == 1) {
        this.alarmRanking = this.getRechargeRateRanking.data_day;
        // this.getAlarmRankingDay(this.stationId);
      } else if (num == 2) {
        this.alarmRanking = this.getRechargeRateRanking.data_month;
        // this.getAlarmRankingMonth(this.stationId);
      }
    },
    getAlarmRanking(stationId) {
      if (this.activeAL == 1) {
        this.getAlarmRankingDay(this.stationId);
      } else if (this.activeAL == 2) {
        this.alarmRanking = this.getRechargeRateRanking.data_month;
        // this.getAlarmRankingMonth(this.stationId);
      }
    },
    getAlarmRankingDay(stationId) {
      this.alarmRanking = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getRechargeRateRanking",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // this.alarmRanking = su.data.data;
            this.getRechargeRateRanking = su.data.date;
            this.alarmRanking = this.getRechargeRateRanking.data_day;
            // console.log(this.getRechargeRateRanking);
            if (this.alarmRanking.length > 10) {
              this.alarmRanking = this.alarmRanking.slice(0, 10);
            }
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    ratioClick(num) {
      this.activeRatio = num;
      if (num == 1) {
        this.getIncomeRatioDay(this.stationId);
      } else if (num == 2) {
        this.getIncomeRatioMonth(this.stationId);
      }
    },
    getIncomeRatio(stationId) {
      if (this.activeRatio == 1) {
        this.getIncomeRatioDay(this.stationId);
      } else if (this.activeRatio == 2) {
        this.getIncomeRatioMonth(this.stationId);
      }
    },
    getIncomeRatioDay(stationId) {
      this.incomeRatioList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getIncomeRatio",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.incomeRatioList = su.data.data;
            this.total_fee = su.data.total_fee;
            let arr = [];
            if (su.data.data.length == 0) {
              arr = [{ name: "无收入", value: 0, income_share: "100%" }];
            } else {
             
              for (let j in this.incomeRatioList) {
                if (this.incomeRatioList[j].type == "ac") {
                  this.incomeRatioList[j].model =
                    this.incomeRatioList[j].model + "交流";
                } else if (this.incomeRatioList[j].type == "dc") {
                  this.incomeRatioList[j].model =
                    this.incomeRatioList[j].model + "直流";
                }

                arr.push({
                  name: this.incomeRatioList[j].model,
                  value: this.incomeRatioList[j].elce_fee,
                  income_share: this.incomeRatioList[j].income_share,
                });
              
              }



              
               
            }
           
            this.drawRatioEcharts(this.total_fee, arr);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
             let arr = [{ name: "无收入", value: 0, income_share: "100%" }];
            this.drawRatioEcharts(this.total_fee, arr);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getIncomeRatioMonth(stationId) {
      this.incomeRatioList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ChargeIncome/getIncomeRatioMonth",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.incomeRatioList = su.data.data;
            this.total_fee = su.data.total_fee;
            let arr = [];
            if (su.data.data.length == 0) {
              arr = [{ name: "无收入", value: 0, income_share: "100%" }];
            } else {
               for (let j in this.incomeRatioList) {
                if (this.incomeRatioList[j].type == "ac") {
                  this.incomeRatioList[j].model =
                    this.incomeRatioList[j].model + "交流";
                } else if (this.incomeRatioList[j].type == "dc") {
                  this.incomeRatioList[j].model =
                    this.incomeRatioList[j].model + "直流";
                }

                arr.push({
                  name: this.incomeRatioList[j].model,
                  value: this.incomeRatioList[j].elce_fee,
                  income_share: this.incomeRatioList[j].income_share,
                });
              
              }
            }

            this.drawRatioEcharts(this.total_fee, arr);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
           let arr = [{ name: "无收入", value: 0, income_share: "100%" }];
            this.drawRatioEcharts(this.total_fee, arr);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawRatioEcharts(total, data) {
      // debugger
      // console.log(data);
      let echart = echarts.init(document.getElementById("ratio-echarts"));
      var option = {
        tooltip: {
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += "总收入" + "<br/>";
            }
            txtCon +=
              arr.marker + arr.data.name + " : " + arr.data.value + " 元";
            return txtCon;
          },
        },
        color: ["#07b4c5", "#22ad50", "#ac266f"],
        legend: {
          bottom: this.width1 > 340 ? 8 : 0,
          left: "center",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10,
          // itemGap:0,//图例之间距离
          textStyle: {
            color: "#6ec5fb",
            fontSize: 10,
          },
          icon: "circle", //图例形状设置
          // data: this.type,
        },
        graphic: [
          //饼图中间数字和文字显示
          {
            type: "text",
            left: "center",
            top: "43%",
            z: 2,
            zlevel: 100,
            style: {
              text: "总收入",
              fill: "#FFFFFD",
              font: "bold Microsoft YaHei",
              fontSize: this.width1 > 340 ? 14 : 12,
            },
          },
          {
            type: "text",
            left: "center",
            top: "52%",
            z: 2,
            zlevel: 100,
            style: {
              text: total,
              fill: "#62cafd",
              fontWeight: 700,
              fontSize: this.width1 > 340 ? 26 : 18,
            },
          },
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["38%", "50%"],
            center: ["50%", "50%"],
            label: {
              //饼图线
              normal: {
                textStyle: {
                  fontSize: 10,
                },
                // formatter: "{b}{per|{c}}\n",
                formatter: (arr) => {
                  //自定义提示信息
                  // console.log(arr);
                  let txtCon = "";
                  // if(arr.length != 0){
                  //   txtCon += "总收入" + '<br/>';
                  // }
                  txtCon +=
                    arr.data.name + "   " + arr.data.income_share + "\n";
                  return txtCon;
                },
                borderWidth: 20,
                borderRadius: 4,
                padding: [0, -40],
                rich: {
                  a: {
                    fontSize: 10,
                    lineHeight: 20,
                    align: "center",
                  },
                  per: {
                    align: "center",
                    fontSize: 10,
                  },
                  b: {
                    color: "#60c8ff",
                  },
                  c: {
                    color: "#60c8ff",
                  },
                },
              },
            },
            data: data,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}  \n {c}", //标题换行，按照自己的格式进行配置
                  // color:"#60c8ff"
                },
                labelLine: {
                  show: true,
                  length: 20,
                  length2: 40,
                },
                borderWidth: 4, //每个扇形直接留有空隙
                borderColor: "#0C1E2A", //空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          },
        ],
      };
      echart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
.charing-revenue {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -o-user-select: none;
  user-select: none;
  .charing-revenue-top {
    width: 98%;
    margin-left: 1%;
    height: 62px;
    background-color: #0b212e;
    margin-top: 18px;
    .top-left {
      color: #feffff;
      float: left;
      line-height: 62px;
      margin-left: 20px;
    }
    .top-right {
      float: right;
      margin-right: 20px;
      margin-top: 11px;
    }
  }
  .charing-revenue-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 18px;
    .top {
      .income-ranking {
        width: 24%;
        background: url(../../assets/img/ydjk_01.png) no-repeat;
        background-size: 100% 100%;
        float: left;
        .income-data {
          width: 94%;
          height: 85%;
          margin-left: 3%;
          padding-top: 13%;
          .income-list {
            width: 100%;
            height: 30%;
            border-bottom: 1px solid #0c2633;
            span {
              display: inline-block;
            }
            .list-bg {
              float: left;
              width: 5px;
              height: 50%;
              margin-top: 6%;
              background-color: #4b8eff;
              margin-right: 4%;
            }
            .list-bg2 {
              background-color: #ff7a7b;
            }
            .list-bg3 {
              background-color: #fdce5c;
            }
            .income-title {
              margin-top: 9%;
              float: left;
              font-size: 16px;
              color: #4693bd;
              // font-weight: 600;
            }
            .income-money {
              margin-top: 9%;
              color: #ffffff;
              float: right;
              font-size: 22px;
              color: #ffffff;
              font-weight: 500;
              .yuan {
                float: right;
                font-size: 12px;
                margin-top: 6%;
                margin-left: 6px;
              }
              .yuanA {
                margin-top: 16%;
              }
            }
          }
          .income-list3 {
            border-bottom: 0;
          }
        }
      }
      .income-loss {
        width: 50%;
        background: url(../../assets/img/ydjk_02.png) no-repeat;
        background-size: 100% 100%;
        margin-left: 1%;
        float: left;
        .income-loss-box {
          width: 60%;
          height: 100%;
          float: left;
          position: relative;
          .i-l-title {
            position: absolute;
            width: 100%;
            // height: 11%;
            top: 0;
            .title-l {
              float: left;
              color: #feffff;
              margin-top: 3%;
              margin-left: 8%;
            }
            .title-r {
              float: right;
              font-size: 14px;
              color: #026db1;
              margin-top: 3%;
              z-index: 9999;
              .title-r-day {
                cursor: pointer;
                z-index: 9999;
              }
              .title-r-month {
                cursor: pointer;
                z-index: 9999;
              }
              .active {
                color: #ade0ff;
              }
            }
          }
          .income-loss-echarts {
            width: 100%;
            height: 100%;
            position: relative;
            #ilsf-echarts {
              position: absolute;
              top: 0;
            }
          }
        }
        .income-ranking-box {
          width: 36%;
          height: 100%;
          float: right;
          overflow-y: hidden;
          .ir-title {
            margin-top: 4%;
            span {
              display: inline-block;
            }
            .ir-title-l {
              float: left;
              color: #feffff;
            }
            .ir-title-r {
              float: left;
              margin-left: 30%;
              color: #026db1;
              font-size: 14px;
              .day {
                cursor: pointer;
              }
              .month {
                cursor: pointer;
              }
              .year {
                cursor: pointer;
              }
              .active {
                color: #ade0ff;
              }
            }
          }
          .ir-list {
            height: 80%;
            margin-top: 3%;
            ul {
              list-style: none;
              li {
                text-align: left;
                margin-top: 4.2%;
                span {
                  display: inline-block;
                }
                .number {
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  line-height: 16px;
                  background-color: #959595;
                  color: #fffeff;
                  text-align: center;
                  margin-right: 12px;
                  font-size: 10px;
                }
                .station-name {
                  width: 42%;
                  color: #61caff;
                  font-size: 12px;
                  vertical-align: top;
                  margin-top: 2px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .money {
                  width: 40%;
                  color: #61caff;
                  font-size: 12px;
                  float: right;
                  display: flex;
                  justify-content: flex-end;
                  margin-right: 4%;
                  .money-num {
                    display: inline-block;
                    text-align: right;
                    margin-right: 4px;
                    line-height: 16px;
                    width: 50%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
                .arrow {
                  width: 10px;
                  height: 12px;
                  margin-left: 12px;
                }
                .arrow-up {
                  background: url(../../assets/img/icon.png) -239px -142px
                    no-repeat;
                }
                .arrow-down {
                  background: url(../../assets/img/icon.png) -239px -171px
                    no-repeat;
                }
              }
              li:nth-child(1) {
                .number {
                  background-color: #f73939;
                }
              }
              li:nth-child(2) {
                .number {
                  background-color: #ff7815;
                }
              }
              li:nth-child(3) {
                .number {
                  background-color: #36b66b;
                }
              }
              li:nth-child(4) {
                .number {
                  background-color: #4a90ff;
                }
              }
              li:nth-child(5) {
                .number {
                  background-color: #6f31ff;
                }
              }
            }
          }
        }
      }
      .operation-index {
        width: 24%;
        background: url(../../assets/img/ydjk_01.png) no-repeat;
        background-size: 100% 100%;
        float: right;
        position: relative;
        .oi-title {
          margin-top: 3%;
          margin-left: 10%;
          position: absolute;
          width: 100%;
          top: 0;
          span {
            display: inline-block;
          }
          .oi-title-l {
            float: left;
            color: #feffff;
          }
          .oi-title-r {
            float: left;
            margin-left: 38%;
            color: #026db1;
            font-size: 14px;
            .day {
              cursor: pointer;
            }
            .month {
              cursor: pointer;
            }
            .year {
              cursor: pointer;
            }
            .active {
              color: #ade0ff;
            }
          }
        }
        .operation-index-echarts {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom {
      margin-top: 20px;
      .order-status {
        width: 24%;
        background: url(../../assets/img/ydjk_01.png) no-repeat;
        background-size: 100% 100%;
        float: left;
        .ot-title {
          margin-top: 3%;
          margin-left: 10%;
          width: 100%;
          span {
            display: inline-block;
          }
          .ot-title-l {
            float: left;
            color: #feffff;
          }
          .ot-title-r {
            float: left;
            margin-left: 38%;
            color: #026db1;
            font-size: 14px;
            .day {
              cursor: pointer;
            }
            .month {
              cursor: pointer;
            }
            .year {
              cursor: pointer;
            }
            .active {
              color: #ade0ff;
            }
          }
        }
        .order-status-echarts {
          width: 100%;
          height: 88%;
        }
      }
      .charge-distribution {
        width: 50%;
        background: url(../../assets/img/ydjk_02.png) no-repeat;
        background-size: 100% 100%;
        margin-left: 1%;
        float: left;
        .charge-distribution-box {
          width: 60%;
          height: 100%;
          float: left;
          position: relative;
          .c-d-title {
            position: absolute;
            width: 100%;
            // height: 11%;
            top: 0;
            .title-l {
              float: left;
              color: #feffff;
              margin-top: 3%;
              margin-left: 8%;
            }
            .title-r {
              float: right;
              font-size: 14px;
              color: #026db1;
              margin-top: 3%;
              z-index: 9999;
              .title-r-day {
                cursor: pointer;
                z-index: 9999;
              }
              .title-r-month {
                cursor: pointer;
                z-index: 9999;
              }
              .active {
                color: #ade0ff;
              }
            }
          }
          .charge-distribution-echarts {
            width: 100%;
            height: 100%;
            position: relative;
            #cdfb-echarts {
              position: absolute;
              top: 0;
            }
          }
        }
        .alarm-box {
          width: 36%;
          height: 100%;
          float: right;
          overflow-y: hidden;
          .alarm-title {
            margin-top: 4%;
            span {
              display: inline-block;
            }
            .alarm-title-l {
              float: left;
              color: #feffff;
            }
            .alarm-title-r {
              float: left;
              margin-left: 20%;
              color: #026db1;
              font-size: 14px;
              .day {
                cursor: pointer;
              }
              .month {
                cursor: pointer;
              }
              .year {
                cursor: pointer;
              }
              .active {
                color: #ade0ff;
              }
            }
          }
          .alarm-list {
            height: 80%;
            margin-top: 3%;
            ul {
              list-style: none;
              li {
                text-align: left;
                margin-top: 4.2%;
                span {
                  display: inline-block;
                }
                .number {
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  line-height: 16px;
                  background-color: #959595;
                  color: #fffeff;
                  text-align: center;
                  margin-right: 12px;
                  font-size: 10px;
                }
                .station-name {
                  width: 42%;
                  color: #61caff;
                  font-size: 12px;
                  vertical-align: top;
                  margin-top: 2px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .money {
                  width: 40%;
                  color: #61caff;
                  font-size: 12px;
                  float: right;
                  display: flex;
                  justify-content: flex-end;
                  margin-right: 4%;
                  .money-num {
                    display: inline-block;
                    text-align: right;
                    margin-right: 4px;
                    line-height: 16px;
                    width: 50%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
                .arrow {
                  width: 10px;
                  height: 12px;
                  margin-left: 12px;
                }
                .arrow-up {
                  background: url(../../assets/img/icon.png) -239px -142px
                    no-repeat;
                }
                .arrow-down {
                  background: url(../../assets/img/icon.png) -239px -171px
                    no-repeat;
                }
              }
              li:nth-child(1) {
                .number {
                  background-color: #f73939;
                }
              }
              li:nth-child(2) {
                .number {
                  background-color: #ff7815;
                }
              }
              li:nth-child(3) {
                .number {
                  background-color: #36b66b;
                }
              }
              li:nth-child(4) {
                .number {
                  background-color: #4a90ff;
                }
              }
              li:nth-child(5) {
                .number {
                  background-color: #6f31ff;
                }
              }
            }
          }
        }
      }
      .income-ratio {
        width: 24%;
        background: url(../../assets/img/ydjk_01.png) no-repeat;
        background-size: 100% 100%;
        float: right;
        .income-ratio-title {
          margin-top: 3%;
          margin-left: 10%;
          width: 100%;
          span {
            display: inline-block;
          }
          .income-ratio-title-l {
            float: left;
            color: #feffff;
          }
          .income-ratio-title-r {
            float: left;
            margin-left: 38%;
            color: #026db1;
            font-size: 14px;
            .day {
              cursor: pointer;
            }
            .month {
              cursor: pointer;
            }
            .year {
              cursor: pointer;
            }
            .active {
              color: #ade0ff;
            }
          }
        }
        .income-ratio-echarts {
          width: 100%;
          height: 88%;
        }
      }
    }
  }
}
@media screen and (min-width: 1270px) and (max-width: 1367px) {
  .charing-revenue {
    .charing-revenue-bottom
      .top
      .income-ranking
      .income-data
      .income-list
      .income-title {
      margin-top: 8.5%;
    }
    .charing-revenue-bottom
      .top
      .income-ranking
      .income-data
      .income-list
      .income-money {
      margin-top: 8.5%;
    }
    .charing-revenue-bottom
      .top
      .income-ranking
      .income-data
      .income-list
      .income-title {
      font-size: 14px;
    }
    .charing-revenue-bottom
      .top
      .income-ranking
      .income-data
      .income-list
      .income-money {
      font-size: 18px;
    }
    .charing-revenue-bottom
      .top
      .income-ranking
      .income-data
      .income-list
      .income-money
      .yuan {
      margin-top: 3%;
    }
  }
}
@media screen and (min-width: 1570px) and (max-width: 1710px) {
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-r {
    margin-left: 26%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-r {
    margin-left: 34%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-r {
    margin-left: 34%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-r {
    margin-left: 10%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li {
    margin-top: 3%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li {
    margin-top: 3%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-r {
    margin-left: 34%;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1569px) {
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-r {
    margin-left: 22%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-r {
    margin-left: 30%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-r {
    margin-left: 30%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-r {
    margin-left: 10%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li {
    margin-top: 2.6%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li {
    margin-top: 2.6%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-r {
    margin-left: 30%;
  }
}
@media screen and (min-width: 1310px) and (max-width: 1439px) {
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-r {
    margin-left: 18%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-r {
    margin-left: 28%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-r {
    margin-left: 28%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-r {
    margin-left: 8%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li {
    margin-top: 2.2%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li {
    margin-top: 2.2%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-r {
    margin-left: 28%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li
    .money {
    width: 38%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li
    .money {
    width: 38%;
  }
}
@media screen and (max-width: 1309px) {
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-r {
    margin-left: 24%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li
    .money {
    width: 38%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li
    .money {
    width: 38%;
  }
}
@media screen and (max-width: 1367px) {
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-loss-box
    .i-l-title
    .title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-title
    .ir-title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-loss-box
    .i-l-title
    .title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .operation-index
    .oi-title
    .oi-title-r {
    margin-left: 34%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .order-status
    .ot-title
    .ot-title-r {
    margin-left: 34%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .charge-distribution-box
    .c-d-title
    .title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .charge-distribution-box
    .c-d-title
    .title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-title
    .alarm-title-r {
    margin-left: 15%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .charge-distribution
    .alarm-box
    .alarm-list
    ul
    li {
    margin-top: 1.6%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .top
    .income-loss
    .income-ranking-box
    .ir-list
    ul
    li {
    margin-top: 1.6%;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-l {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-r {
    font-size: 12px;
  }
  .charing-revenue
    .charing-revenue-bottom
    .bottom
    .income-ratio
    .income-ratio-title
    .income-ratio-title-r {
    margin-left: 34%;
  }
}
</style>
<style lang="scss">
.charing-revenue {
  .top-right {
    .el-select {
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #58b6ea !important;
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #58b6ea !important;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #58b6ea !important;
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #58b6ea !important;
      }
      .el-input__inner {
        border: 1px solid #60c8ff !important;
        background-color: transparent !important;
        color: #58b6ea !important;
      }
      .el-input {
        .el-select__caret {
          color: #58b6ea !important;
        }
      }
    }
  }
}
.charging-body .el-select-dropdown {
  border: 1px solid #135a69 !important;
  background-color: #132b39 !important;
  ul {
    li {
      span {
        color: #58b6ea !important;
      }
    }
    li:hover {
      background-color: #317dd6 !important;
      span {
        color: #fff !important;
      }
    }
  }
  .popper__arrow {
    display: none !important;
  }
}
.el-popper {
  margin-top: 0 !important;
}
.charging-body .el-select-dropdown__item.hover,
.charging-body .el-select-dropdown__item:hover {
  background-color: #317dd6 !important;
  span {
    color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalysis/chargingRevenue.vue